/* mri */
import "bootstrap/dist/css/bootstrap.css"

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

/* mri */
import "@fontsource/yanone-kaffeesatz"
import "bootstrap/dist/js/bootstrap.js"

/*
import { ref } from 'vue'
import {useFixedHeader} from 'vue-use-fixed-header'
*/

/* generated */
createApp(App).use(router).mount('#app')
